import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="You">you</header>
    </div>
  );
}

export default App;
